import { DCPLabel } from '@hakimo-ui/hakimo/types';

export const defaultLabel: DCPLabel = {
  doorMarkers: [],
  cameraPosition: 'unknown',
  floorMarker: null,
};
